import React, { PureComponent } from 'react';

import classnames from 'classnames';
import { FormControl } from 'components/form';
import { Grid } from 'components/grid';
import { Input } from 'components/input';
import MediaUploadGroup from 'components/input/group/MediaUploadGroup';
import { I18n } from 'components/translate';
import { rawTextLength } from 'helpers/String';
import { FileService } from 'modules/file';
import { ENTITY_TYPE } from 'modules/file/constants';
import PropTypes from 'prop-types';

import { MAX_DESCRIPTION_LENGTH } from '../../../constants';

import './SalesInfoPageConfig.scss';

class SalesInfoPageConfig extends PureComponent {
  static propTypes = {
    description: PropTypes.string,
    mediaVideoUrl: PropTypes.string,
    media: PropTypes.object,
    image: PropTypes.object,
    onContentChange: PropTypes.func,
    setMediaUrl: PropTypes.func,
    onError: PropTypes.func,
    handleMediaChange: PropTypes.func,
    className: PropTypes.string
  };

  labelPath = 'sales_manager.sales_info.sales_page';

  get className() {
    const { className } = this.props;

    return classnames('sales_info_page_config', className);
  }

  get rawContentLength() {
    return rawTextLength(this.props.description || '');
  }

  get remainingCharacters() {
    return MAX_DESCRIPTION_LENGTH - this.rawContentLength;
  }

  get remainingCharactersClass() {
    return classnames('char__limit', {
      char__limit_exceed: this.remainingCharacters < 0
    });
  }

  render() {
    const {
      description = '',
      onContentChange,
      media,
      image,
      mediaVideoUrl,
      setMediaUrl,
      onError
    } = this.props;

    return (
      <Grid block className={this.className}>
        <Grid.Title data-test="grid-title">
          <I18n label="general.sales_page" />
        </Grid.Title>
        <div className="sales_info__description">
          <p className="sales_info_page_config__description">
            <I18n label={`${this.labelPath}.description`} />
          </p>
          <p className="sales_info_page_config__info">
            <I18n label={`${this.labelPath}.info`} />
          </p>
        </div>

        <label
          id="description"
          className="sales_info_page_config__label__description"
        >
          <I18n label="general.description" />

          <span className={this.remainingCharactersClass}>
            {`${this.remainingCharacters} `}
            <I18n label="general.characters" />
          </span>
        </label>

        <div data-test="input-description" className="card__description">
          <Input
            reduced
            placeholder="general.editor_placeholder"
            value={description}
            onChange={onContentChange}
            maxLength={MAX_DESCRIPTION_LENGTH}
            name="description"
            type="textarea"
            className="description__textarea"
          />
        </div>

        <FormControl data-test="media-upload">
          <MediaUploadGroup
            name="media"
            labelValue="general.media"
            entityType={ENTITY_TYPE.MEMBERSHIP_PURCHASE_DATA}
            value={media || image}
            mediaUrl={mediaVideoUrl}
            setMediaUrl={setMediaUrl}
            onCancelUpload={FileService.onCancelUpload}
            setCentralError={onError}
            onChange={this.props.handleMediaChange}
          />
        </FormControl>
      </Grid>
    );
  }
}

export default SalesInfoPageConfig;
